import { render, staticRenderFns } from "./columnGuard.vue?vue&type=template&id=2605cabc&scoped=true"
import script from "./columnGuard.vue?vue&type=script&lang=js"
export * from "./columnGuard.vue?vue&type=script&lang=js"
import style0 from "./columnGuard.vue?vue&type=style&index=0&id=2605cabc&prod&scoped=true&lang=css"
import style1 from "./columnGuard.vue?vue&type=style&index=1&id=2605cabc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605cabc",
  null
  
)

export default component.exports